module.exports = __webpack_public_path__ + "img/duck-blue.ec9bc83d.svg";